import React from 'react';

const Settings = () => {
  return (
    <div className="page">
      <h1>Settings</h1>
      <p>Configure application settings here.</p>
      <div style={{ padding: '20px', background: 'white', borderRadius: '8px', marginTop: '20px' }}>
        <p>This feature is coming soon...</p>
      </div>
    </div>
  );
};

export default Settings;
